var checkCustomInputs = function() {
	var classPrefix = 'ci';

	$('input[type=checkbox], input[type=radio]').each(function() {
		var $input = $(this);

		if ($input.hasClass(classPrefix + '-enabled')) {
			return;
		}

		if ($input.closest('label').length == 0) {
			$input.wrap('<label/>');
		}

		$input.wrap('<span class="' + classPrefix + '"/>');
		$input.after('<span class="' + classPrefix + '-input"/>');
		$input.addClass(classPrefix + '-enabled');

		$input.on('click', function(e) {
			if ($input.attr('readonly')) {
				e.preventDefault();
			}
		});
	});

	checkCustomInputLabels();
};

var checkCustomInputLabels = function() {
	var classPrefix = 'ci';

	$('.' + classPrefix + '-enabled').each(function() {
		var $label = $(this).closest('label');

		if ($(this).prop('disabled')) {
			$label.addClass('input-disabled');
		} else {
			$label.removeClass('input-disabled');
		}

		if ($(this).prop('readonly')) {
			$label.addClass('input-readonly');
		} else {
			$label.removeClass('input-readonly');
		}
	});
};

